module.exports = __webpack_public_path__ + "img/Upscaler02.d14dda26.png";